// Maps concrete pathnames to route patterns for aggregation.
const PATTERNS: { re: RegExp; pattern: string }[] = [
  { re: /^\/biler\/[^/]+\/[^/]+\/[^/]+\/?$/, pattern: '/biler/:brand/:model/:variant' },
  { re: /^\/biler\/?$/, pattern: '/biler' },
  { re: /^\/maerker\/[^/]+\/?$/, pattern: '/maerker/:brand' },
  { re: /^\/maerker\/?$/, pattern: '/maerker' },
  { re: /^\/nyheder\/[^/]+\/?$/, pattern: '/nyheder/:slug' },
  { re: /^\/nyheder\/?$/, pattern: '/nyheder' },
  { re: /^\/magasin\/[^/]+\/?$/, pattern: '/magasin/:slug' },
  { re: /^\/magasin\/?$/, pattern: '/magasin' },
  { re: /^\/anmeldelser\/udgiver\/[^/]+\/?$/, pattern: '/anmeldelser/udgiver/:slug' },
  { re: /^\/anmeldelser\/?$/, pattern: '/anmeldelser' },
  { re: /^\/community\/sporgsmaal\/nyt\/?$/, pattern: '/community/sporgsmaal/nyt' },
  { re: /^\/community\/sporgsmaal\/[^/]+(\/[^/]+)?\/?$/, pattern: '/community/sporgsmaal/:id' },
  { re: /^\/community\/erfaringer\/ny\/?$/, pattern: '/community/erfaringer/ny' },
  { re: /^\/community\/erfaringer\/?$/, pattern: '/community/erfaringer' },
  { re: /^\/community\/eksperter\/sadan-bliver-du\/?$/, pattern: '/community/eksperter/sadan-bliver-du' },
  { re: /^\/community\/eksperter\/[^/]+\/?$/, pattern: '/community/eksperter/:username' },
  { re: /^\/community\/eksperter\/?$/, pattern: '/community/eksperter' },
  { re: /^\/community\/model\/[^/]+\/[^/]+\/?$/, pattern: '/community/model/:brand/:model' },
  { re: /^\/community\/profil\/mig\/?$/, pattern: '/community/profil/mig' },
  { re: /^\/community\/profil\/[^/]+\/?$/, pattern: '/community/profil/:username' },
  { re: /^\/community\/?$/, pattern: '/community' },
  { re: /^\/admin(\/.*)?$/, pattern: '/admin/*' },
];

export function toPattern(pathname: string): string {
  const clean = pathname.replace(/\/+$/, '') || '/';
  for (const { re, pattern } of PATTERNS) {
    if (re.test(clean) || re.test(clean + '/')) return pattern;
  }
  return clean;
}
